import { render } from "./dialogEdit.vue?vue&type=template&id=35998346"
import script from "./dialogEdit.vue?vue&type=script&lang=js"
export * from "./dialogEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__